<template>
  <div class= "maintainTypeManageList">
    <el-card>
      <el-button type="primary" slot="header" @click="back()" v-if="type === 2">{{$t('lang.btn_returnMaintainTypeManage')}}</el-button>
      <el-button type="primary" slot="header" @click="back()" v-if="type === 3">{{$t('lang.btn_returnMaintianType2')}}</el-button>
      <el-button type="primary" slot="header" @click="back()" v-if="type === 4">{{$t('lang.btn_returnMaintianType3')}}</el-button>
      <el-button type="primary" slot="header" @click="back()" v-if="type === 5">{{$t('lang.btn_returnMaintianType4')}}</el-button>
      <el-button type="primary" slot="header" @click="add()" v-if="type === 1">{{$t('lang.btn_addMaintianType1')}}</el-button>
      <el-button type="primary" slot="header" @click="add()" v-if="type === 2">{{$t('lang.btn_addMaintianType2')}}</el-button>
      <el-button type="primary" slot="header" @click="add()" v-if="type === 3">{{$t('lang.btn_addMaintianType3')}}</el-button>
      <el-button type="primary" slot="header" @click="add()" v-if="type === 4">{{$t('lang.btn_addMaintianType4')}}</el-button>
      <el-button type="primary" slot="header" @click="add()" v-if="type === 5">{{$t('lang.btn_addMaintianType5')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="maintainTypeManagecheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column prop="name" :label='column'></el-table-column>
        <el-table-column prop="groupsName" label='所属集团'></el-table-column>
        <el-table-column prop="isDefault" :label="$t('lang.lab_default')">
          <template slot-scope="scope">
            <span v-if="scope.row.isDefault === 1">{{$t('lang.lab_isYes')}}</span>
            <span  v-else>{{$t('lang.lab_isNo')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width3">
        <template slot-scope="scope">
          <el-button @click="details(scope.row.id)">下级</el-button>
          <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
          <el-button @click="commonPhrases(scope.row)">常用语</el-button>
          <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      @closed="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws6" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="isTitle" prop="name" class="input-width">
          <input style="display: none"/>
          <el-input v-model="form.name" :placeholder="$t('lang.lab_pleaseEnterMTtext')" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_onlyToProperty')" prop="isPropertyShow">
          <el-radio v-model="form.isPropertyShow" :label="1">{{$t('lang.lab_isYes')}}</el-radio>
          <el-radio v-model="form.isPropertyShow" :label="0">{{$t('lang.lab_isNo')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_default')" prop="isDefault" v-if="type === 1">
          <el-radio v-model="form.isDefault" :label="1">{{$t('lang.lab_isYes')}}</el-radio>
          <el-radio v-model="form.isDefault" :label="0">{{$t('lang.lab_isNo')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_groupsName')" prop="groupsId" v-if="type === 1">
          <el-select v-model="form.groupsId" :placeholder="$t('lang.plh.sel')">
						<el-option v-for='(item,index) in groupsList' :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('form')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:maintainTypeManageList
 *@Description:报事类型设置
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-16
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isDisabled: true, // 保存的可点击
      type: 1, // 1:一级报事 2：二级报事 3：三级报事 4：四级报事 5：五级报事
      isPopupPage: false, // 弹框的显示控制
      isAdd: false, // 标识新增(true)或编辑(false)
      id: '', // id
      editId: '', // 正在编辑的ID
      title: '', // 弹窗标题
      isTitle: '', // 弹窗label
      column: this.$i18n.t('lang.lab_maintianType1'), // 列表标题
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 列表数据
      groupsList: [], // 集团数据
      multipleSelection: [], // 多选框
      maintainTypeManagecheckbox: require('@/config/enum').maintainTypeManagecheckbox, // 是否隐藏复选框
      form: {
        name: '',
        isDefault: 0,
        isPropertyShow: '',
        groupsId: ''
      }, // 弹窗列表数据
      rules: {
        name: [{ required: true, message: this.$i18n.t('lang.lab_pleaseEnterMTtext'), trigger: 'blur' }],
        isPropertyShow: [{ required: true, message: this.$i18n.t('lang.lab_pleaseSeletcOnlyToProperty'), trigger: 'change' }],
        groupsId: [{ required: true, message: this.$i18n.t('lang.pla_inputKeyword'), trigger: 'blur' }],
      }
    }
  },
  created() {
    this.id = this.gardenId
    this.getData()
    this.getGroups()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.id = this.gardenId
      this.type = 1
      this.getData()
    },
    form: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
        this.multipleSelection = val
    },
    // 获取表格数据
    getData() {
      let loading = this.$loading()
      this.$get(`/maintainTypes?type=${this.type}&Pid=${this.id}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )      
    },
    getGroups() {
      this.$post(`/Groups/selectall?pageNo=1&pageSize=99`).then(
              res => {
                this.groupsList = res.list.rows
                console.log(this.groupsList)
              },
              err => {
              this.$message.error(err)
            })
    },
    // 返回
    back() {
      if (this.type === 2) {
        this.type = 1
        this.column = this.$i18n.t('lang.lab_maintianType1')
      } else if (this.type === 3) {
        this.type = 2
        this.column = this.$i18n.t('lang.lab_maintianType2')
      } else if (this.type === 4) {
        this.type = 3
        this.column = this.$i18n.t('lang.lab_maintianType3')
      } else if (this.type === 5) {
        this.type = 4
        this.column = this.$i18n.t('lang.lab_maintianType4')
      } else {
        this.column = this.$i18n.t('lang.lab_maintianType5')
      }
      let loading = this.$loading()
      this.$get(`/maintainTypesParent/${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.id = res.id
            this.commit()
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加
    add() {
      if (this.type === 1) {
        this.title = this.$i18n.t('lang.btn_addMaintianType1')
        this.isTitle = this.$i18n.t('lang.lab_maintianType1')
      } else if (this.type === 2) {
        this.title = this.$i18n.t('lang.btn_addMaintianType2')
        this.isTitle = this.$i18n.t('lang.lab_maintianType2')
      } else if (this.type === 3) {
        this.title = this.$i18n.t('lang.btn_addMaintianType3')
        this.isTitle = this.$i18n.t('lang.lab_maintianType3')
      } else if (this.type === 4) {
        this.title = this.$i18n.t('lang.btn_addMaintianType4')
        this.isTitle = this.$i18n.t('lang.lab_maintianType4')
      } else if (this.type === 5) {
        this.title = this.$i18n.t('lang.btn_addMaintianType5')
        this.isTitle = this.$i18n.t('lang.lab_maintianType5')
      }
      this.isPopupPage = true
      this.isAdd = true
      this.form.isDefault = 0
    },
    // 编辑
    edit(rowData) {
      if (this.type === 1) {
        this.title = this.$i18n.t('lang.lab_modifyMaintianType1')
        this.isTitle = this.$i18n.t('lang.lab_maintianType1')
      } else if (this.type === 2) {
        this.title = this.$i18n.t('lang.lab_modifyMaintianType2')
        this.isTitle = this.$i18n.t('lang.lab_maintianType2')
      } else if (this.type === 3) {
        this.title = this.$i18n.t('lang.lab_modifyMaintianType3')
        this.isTitle = this.$i18n.t('lang.lab_maintianType3')
      } else if (this.type === 4) {
        this.title = this.$i18n.t('lang.lab_modifyMaintianType4')
        this.isTitle = this.$i18n.t('lang.lab_maintianType4')
      } else if (this.type === 5) {
        this.title = this.$i18n.t('lang.lab_modifyMaintianType5')
        this.isTitle = this.$i18n.t('lang.lab_maintianType5')
      }
      this.editId = rowData.id
      this.form.name = rowData.name
      this.form.isPropertyShow = rowData.isPropertyShow
      this.form.isDefault = rowData.isDefault
      this.form.groupsId = rowData.groupsId
      this.isPopupPage = true
      this.isAdd = false
      this.saveData = JSON.stringify(this.form)
    },
    // 详情
    details(id) {
      if (this.type === 1) {
        this.type = 2
        this.column = this.$i18n.t('lang.lab_maintianType2') 
      } else if (this.type === 2) {
        this.type = 3
        this.column = this.$i18n.t('lang.lab_maintianType3')
      } else if (this.type === 3) {
        this.type = 4
        this.column = this.$i18n.t('lang.lab_maintianType4')
      } else if (this.type === 4) {
        this.type = 5
        this.column = this.$i18n.t('lang.lab_maintianType5')
      }
      this.id = id
      this.commit()
    },
    // 删除
    deleteOne(id) {
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
          this.$delete(`/maintainTypes/` + id).then(
            res => {
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 常用语
    commonPhrases(rowData) {
      console.log(rowData)
      this.$router.push({
          name: 'commonPhrasesList',
          query: { maintaintypeId: rowData.id }
      })
    },
    // 更新
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            let params = {
              type: this.type,
              Pid: this.id,
              name: this.form.name,
              IsPropertyShow: this.form.isPropertyShow,
              IsDefault: this.form.isDefault,
              groupsId: this.form.groupsId
            }
            let loading = this.$loading()
            this.$post(`/maintainTypes`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            let params = {
              name: this.form.name,
              IsPropertyShow: this.form.isPropertyShow,
              IsDefault: this.form.isDefault,
              groupsId: this.form.groupsId
            }
            this.$patch(`/maintainTypes/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
                this.isPopupPage = false
              }
            )
          } 
        }
      })
    },
    // 清空
    resetForm() {
      this.$refs.form.clearValidate()
      this.form.name = ''
      this.form.isPropertyShow = ''
      this.form.isDefault = ''
      this.form.groupsId = ''
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.resetForm()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    }
  }
}
</script>

<style lang= 'scss'>
.maintainTypeManageList{
  .input-width{
    width: 80%;
  }
}
</style>